// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Z6H3Z","rotation":"Spinner_rotation__fvANO"};